import React, { useRef } from 'react';
import './galleryUploader.css';

const GalleryUploader = ({ onUpload, uploading, uploadError, photoUrls, setPhotoUrls, onRemovePhoto }) => {
  const fileInputRef = useRef(null);

  const handlePhotoUpload = async (e) => {
    const files = Array.from(e.target.files);
    
    if (files.length > 0 && onUpload) {
      await onUpload(files);
    } 
  };

  const handleRemovePhoto = (index) => {
    if (onRemovePhoto) {
      onRemovePhoto(index);
    } else {
      const filteredUrls = photoUrls.filter((_, i) => i !== index);
      setPhotoUrls(filteredUrls);
    }
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  return (
    <div className="gallery-uploader__container">
      <div className="gallery-uploader__input-container">
        <label className="gallery-uploader__title">Fotos del perfil (máximo 5):</label>
        
        {/* Hidden file input */}
        <input
          ref={fileInputRef}
          type="file"
          multiple
          accept="image/*"
          onChange={handlePhotoUpload}
          disabled={uploading || photoUrls.length >= 5}
          className="gallery-uploader__hidden-input"
          style={{ display: 'none' }}
        />
        
        {/* Custom styled button that looks like native file input */}
        <div className="gallery-uploader__file-input-wrapper">
          <button
            type="button"
            onClick={handleButtonClick}
            disabled={uploading || photoUrls.length >= 5}
            className="gallery-uploader__custom-button"
          >
            Seleccionar archivos
          </button>
          <span className="gallery-uploader__file-text">
            {photoUrls.length > 0 ? `${photoUrls.length} archivo${photoUrls.length !== 1 ? 's' : ''} seleccionado${photoUrls.length !== 1 ? 's' : ''}` : 'Ningún archivo seleccionado'}
          </span>
        </div>
      </div>

      {uploading && <p className="gallery-uploader__uploading">Subiendo...</p>}
      {uploadError && <p className="gallery-uploader__error">Error al subir las fotos</p>}

      <div className="gallery-uploader__photos">
        {(Array.isArray(photoUrls) ? photoUrls : []).map((url, index) => (
          <div key={index} className="gallery-uploader__photo-container">
            <button
              type="button"
              className="gallery-uploader__remove-button"
              onClick={() => handleRemovePhoto(index)}
            >
              ×
            </button>
            <img src={url} alt={`Photo ${index + 1}`} className="gallery-uploader__photo" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default GalleryUploader;
